import {match} from 'ts-pattern';

import {CSSProperties} from 'react';

import {ResizeHandle} from '../types/ResizeHandle';

const EDGE_START = '0%';
const EDGE_MIDDLE = '50%';
const EDGE_END = '100%';

const handleCursor = (handle: ResizeHandle) =>
  match<ResizeHandle, CSSProperties['cursor']>(handle)
    .with('n', 's', () => 'ns-resize')
    .with('e', 'w', () => 'ew-resize')
    .with('ne', 'sw', () => 'nesw-resize')
    .with('nw', 'se', () => 'nwse-resize')
    .exhaustive();

const verticalEdge = (handle: ResizeHandle) =>
  match(handle)
    .with('n', 'ne', 'nw', () => EDGE_START)
    .with('s', 'se', 'sw', () => EDGE_END)
    .with('e', 'w', () => EDGE_MIDDLE)
    .exhaustive();

const horizontalEdge = (handle: ResizeHandle) =>
  match(handle)
    .with('w', 'nw', 'sw', () => EDGE_START)
    .with('e', 'ne', 'se', () => EDGE_END)
    .with('n', 's', () => EDGE_MIDDLE)
    .exhaustive();

export const getResizeHandleStyle = (handle: ResizeHandle): CSSProperties => ({
  top: verticalEdge(handle),
  left: horizontalEdge(handle),
  cursor: handleCursor(handle),
});
